'use client';

import { useEffect, useState } from 'react';
import { getClasses } from '@/classes';
import { Component } from '@/shared';
import { ThemeChoice, readThemeChoice, applyTheme } from '@/theme';

export default function ThemeToggle({ component, }: { component: Component }) {
  const { classes, } = component;
  const [choice, setChoice,] = useState<ThemeChoice>(`light`);

  useEffect(() => {
    setChoice(readThemeChoice());

    const onStorage = (e: StorageEvent) => {
      if (e.key !== `theme`) return;
      const c = readThemeChoice();
      setChoice(c);
      applyTheme(c);
    };

    window.addEventListener(`storage`, onStorage);
    return () => window.removeEventListener(`storage`, onStorage);
  }, []);

  const onClick = () => {
    const n: ThemeChoice = choice === `dark` ? `light` : `dark`;
    localStorage.setItem(`theme`, n);
    setChoice(n);
    applyTheme(n);
  };

  return (
    <button
      className={getClasses([`theme-toggle-component`, `theme-toggle--${choice}`, classes,])}
      onClick={onClick}
      type="button"
      aria-label={`Theme: ${choice}`}
      title={`theme: ${choice}`}
    >
      {choice === `light` && (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="1.25em" height="1.25em">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
        </svg>
      )}
      {choice === `dark` && (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="1.25em" height="1.25em">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
}
